export const TextMessagesIcon = () => (
   <svg
      xmlns="http://www.w3.org/2000/svg"
      width="19"
      height="19"
      viewBox="0 0 19 19"
      fill="none"
   >
      <path
         d="M5.12939 15.6585L6.27237 14.7441L6.28077 14.7377C6.51905 14.5471 6.63929 14.4509 6.77345 14.3823C6.8938 14.3208 7.02215 14.2761 7.15454 14.2489C7.30377 14.2183 7.45921 14.2183 7.77124 14.2183H14.282C15.1204 14.2183 15.5401 14.2183 15.8607 14.0549C16.1429 13.9111 16.3725 13.6814 16.5164 13.3992C16.6797 13.0786 16.6797 12.6594 16.6797 11.8209V6.11594C16.6797 5.27751 16.6797 4.85766 16.5164 4.53711C16.3725 4.25487 16.1425 4.02556 15.8602 3.88175C15.5394 3.71826 15.1199 3.71826 14.2798 3.71826H5.57983C4.73976 3.71826 4.3194 3.71826 3.99854 3.88175C3.71629 4.02556 3.48699 4.25487 3.34318 4.53711C3.17969 4.85798 3.17969 5.27833 3.17969 6.11841V14.7217C3.17969 15.5209 3.17969 15.9205 3.34353 16.1257C3.48602 16.3043 3.70201 16.4081 3.93042 16.4079C4.19305 16.4076 4.50527 16.1578 5.12939 15.6585Z"
         stroke="white"
         strokeWidth="2"
         strokeLinecap="round"
         strokeLinejoin="round"
      />
   </svg>
)
